import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { PAGES, LEGAL } from "@/lib/legal";

export default function LegalPage() {
  const { slug } = useParams();
  const page = PAGES[slug];
  useEffect(() => {
    if (page) document.title = `${page.title} | Sconto.Market`;
    window.scrollTo(0, 0);
  }, [page]);
  if (!page) return <Navigate to="/" replace />;
  return (
    <main className="max-w-3xl mx-auto px-5 py-12 space-y-8" data-testid={`legal-page-${slug}`}>
      <div>
        <span className="tag text-[#555]">Informazioni legali</span>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-1">{page.title}</h1>
        <p className="text-xs text-[#555] mt-2">Ultimo aggiornamento: {LEGAL.updated}</p>
      </div>
      {page.body}
    </main>
  );
}

export const LegalLinks = () => (
  <nav className="flex flex-wrap gap-x-5 gap-y-2" data-testid="footer-legal-links">
    {Object.entries(PAGES).map(([slug, p]) => (
      <a key={slug} href={`/${slug}`} data-testid={`footer-link-${slug}`} className="tag hover:text-[#FF3333]">{p.title}</a>
    ))}
  </nav>
);
